import { watchEffect } from 'vue'
import { useGridState } from '@/Components/DataGrid/Composables/grid-state'

export const useFilterStateManagement = ({ gridApi }) => {
  const { context } = useGridState()

  context.resetFilters = () => {
    gridApi.value.setFilterModel(null)
    gridApi.value.onFilterChanged()
    gridApi.value.deselectAll()
  }

  const onFilterChanged = () => {
    context.activeFilters = gridApi.value.getFilterModel()
    context.isFiltering = Object.keys(context.activeFilters).length !== 0
  }

  watchEffect(() => {
    if (gridApi.value) {
      gridApi.value.addEventListener('filterChanged', onFilterChanged)
    }
  })
}
